import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormControlsTitle, FormValidationTitle } from "../../../../../Constants/Constants";
import TooltipFormValidation from "./TooltipFormValidation";
import BrowserDefaults from "./BrowserDefaults";
import ValidationForm from "./ValidationForm";

const FormValidationContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FormValidationTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <TooltipFormValidation />
          <BrowserDefaults />
          <ValidationForm />
        </Row>
      </Container>
    </>
  );
};

export default FormValidationContainer;
